import React from "react";

export default function CRMSectionWidget() {
    return (
        <section className="relative overflow-hidden bg-white py-16 max-md:py-12 mb-8">
            {/* Top gradient patch (behind heading) */}
            <div className="pointer-events-none absolute left-1/2 top-40 -translate-x-1/2">
                {/* soft blurred blob */}
                <div
                    className="h-[360px] w-[680px] rounded-full blur-3xl opacity-80"
                    style={{
                        background:
                            "radial-gradient(60% 60% at 50% 40%, rgba(255,122,156,0.55) 0%, rgba(124,92,255,0.35) 45%, rgba(90,210,255,0.35) 75%, rgba(255,255,255,0) 100%)",
                    }}
                />
            </div>

            <div className="relative mx-auto max-w-6xl px-6 max-md:px-4 md:px-10">
                <div className="text-center">
                    <h2  >
                        <span className="font-extrabold">Worldwide coverage.</span> Your search for qualified leads ends here
                    </h2>

                    <p className="mx-auto mt-4 max-w-2xl text-[16px] leading-relaxed text-gray-500 md:text-xl">
                        Our global reach sets us apart. Adopt the leading lead-generation platform and capture every opportunity.
                    </p>
                </div>

                <div className="mt-14 grid gap-6 md:grid-cols-3 max-md:text-center">
                    <div className="rounded-2xl bg-[#F7FAFD] px-8 py-7 max-md:py-3 shadow-[0_12px_30px_rgba(15,30,45,0.06)]">
                        <div className="text-[44px] max-md:text-3xl font-extrabold  leading-none text-[#0B2033]">
                            195
                        </div>
                        <div className="mt-2 text-[13px] font-bold text-blue-600">
                            Countries
                        </div>
                        <p className="mt-4 text-[14px] max-md:text-[16px] leading-relaxed text-[#415666]">
                            Our international database enables you to generate leads from
                            every country.
                        </p>
                    </div>

                    <div className="rounded-2xl bg-[#F7FAFD] px-8 py-7 max-md:py-3 shadow-[0_12px_30px_rgba(15,30,45,0.06)]">
                        <div className="text-[44px] max-md:text-3xl font-extrabold  leading-none text-[#0B2033]">
                            220M
                        </div>
                        <div className="mt-2 text-[13px] font-bold text-blue-600">
                            Companies
                        </div>
                        <p className="mt-4 text-[14px] max-md:text-[16px] leading-relaxed text-[#415666]">
                            Discover better leads than your competition with our unmatched
                            dataset.
                        </p>
                    </div>

                    <div className="rounded-2xl bg-[#F7FAFD] px-8 py-7 max-md:py-3 shadow-[0_12px_30px_rgba(15,30,45,0.06)]">
                        <div className="text-[44px]  max-md:text-3xl font-extrabold  leading-none text-[#0B2033]">
                            45
                        </div>
                        <div className="mt-2 text-[13px] font-bold text-blue-600">
                            Datapoints
                        </div>
                        <p className="mt-4 text-[14px] max-md:text-[16px] leading-relaxed text-[#415666]">
                            Implement the leading lead generation software and never miss a
                            deal again.
                        </p>
                    </div>
                </div>

                {/* Trusted Data row */}
                <div className="mt-16 grid items-center gap-8 md:grid-cols-[220px_1fr]">
                    {/* Icon area (simple approximation) */}
                    <div className="flex justify-center md:justify-end">
                        <div className="relative h-24 w-24">
                            {/* orange star-like blob */}
                            <div className="absolute inset-0 rotate-45 rounded-[28px] bg-indigo-600" />
                            {/* center chip */}
                            <div className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white/60 ring-1 ring-white/90" />
                            {/* small sparkles */}
                            <div className="absolute -left-3 top-6 h-3 w-3 rotate-45 rounded bg-[#0B2033]" />
                            <div className="absolute -right-3 bottom-6 h-3 w-3 rotate-45 rounded bg-[#0B2033]" />
                        </div>
                    </div>

                    <div className="text-center md:text-left">
                        <h3 className="text-[24px] font-extrabold max-md:font-bold text-[#0B2033] md:text-[34px]">
                            Trusted Data, Powered by AI
                        </h3>
                        <p className="mx-auto mt-3 max-w-2xl text-xl max-md:text-base leading-relaxed text-gray-500 md:mx-0">
                            We use advanced AI algorithms and automatic bot detection to
                            filter out irrelevant traffic. This ensures you only receive real,
                            reliable data, so you can trust every insight is based on the
                            highest quality information.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
